<template>
  <div class="status-root">
    <div class="picture">
      <img
        src="../../../../assets/images/warning.png"
        alt="fail icon"
        width="20px"
        height="20px"
      />
    </div>

    <div class="text">
      {{ $t(text) }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusFail",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  mounted() {
    console.log(this.text, "text");
  },
};
</script>

<style scoped lang="scss">
.status-root {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border: 1px solid var(--bg-6);
  border-radius: 10px;
  padding: 10px;
  gap: 10px;
}

.picture {
}

.text {
  color: var(--text-1);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 36.4px */
}
</style>
